import { defineStore } from "pinia";
import { ref } from "vue";

export const useIdentificationStore = defineStore(
  "identification",
  () => {
    const finished = ref(false);

    const $reset = () => {
      finished.value = false;
    };

    const setFinished = () => {
      finished.value = true;
    };

    return {
      $reset,
      finished,
      setFinished,
    };
  },
  {
    persist: true,
  },
);
